export function rando(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

export function slugify(text) {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/&/g, "-")
        .replace(/\//g, "-")
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");
}

// Turn '/ ' to '/'
// export function slasher(text) {
//   return text
//     .toString()
//     .replace(/\/\s+/g, "/")
// }

// Turn '/' to ' / '
export function slasher(text) {
    return text.toString().replace(/\//g, "/ ");
}

export function handleType(type) {
    if (type === "pdf" || type === "PDF") {
        return "PDF";
    } else if (type === "video" || type === "Video") {
        return "Video";
    } else if (type === "link" || type === "Link") {
        return "Link";
    }
}

export function emailBuilder(messages) {
    return messages.join("\r\n\r\n");
}

/**
 * Sort object properties (only own properties will be sorted).
 * @param {object} obj object to sort properties
 * @param {bool} isNumericSort true - sort object properties as numeric value, false - sort as string value.
 * @returns {Array} array of items in [[key,value],[key,value],...] format.
 */
export function sortNameProp(obj, isNumericSort) {
    isNumericSort = isNumericSort || false; // by default text sort
    var sortable = [];
    for (var key in obj)
        if (obj.hasOwnProperty(key)) sortable.push([key, obj[key]]);
    if (isNumericSort)
        sortable.sort(function(a, b) {
            return a[1] - b[1];
        });
    else
        sortable.sort(function(a, b) {
            let initial = a[1].name.toLowerCase(),
                next = b[1].name.toLowerCase();
            if (initial < next) return -1;
            if (initial > next) return 1;
            return 0;
        });
    return sortable; // array in format [ [ key1, val1 ], [ key2, val2 ], ... ]
}



// WEBPACK FOOTER //
// ./src/helpers.js